import { render, staticRenderFns } from "./UserCurrentNotifications.vue?vue&type=template&id=26d156da&"
import script from "./UserCurrentNotifications.vue?vue&type=script&lang=js&"
export * from "./UserCurrentNotifications.vue?vue&type=script&lang=js&"
import style0 from "./UserCurrentNotifications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports